import { ApiBase } from "config";
import { campaign } from "features/campaign/api/query";

const baseUrl = `${ApiBase}/api`;
export const endpoints = {
  member: {
    memberList: `${baseUrl}/member/list`,
    pendingMemberList: `${baseUrl}/member/pendingMember`,
    incompleteRegistrations: `${baseUrl}/member/incompleteRegistrations`,
    sendRegistrationReminder: `${baseUrl}/member/sendReminder`,
    view: `${baseUrl}/member/view`,
    get: `${baseUrl}/member`,
    delete: `${baseUrl}/member/delete`,
    add: `${baseUrl}/member/create`,
    update: `${baseUrl}/member/update`,
    approveMember: `${baseUrl}/member/approveMember`,
    rejectMember: `${baseUrl}/member/rejectMember`,
    approveallMembers: `${baseUrl}/member/approveallMembers`,
    importMemebrExcel: `${baseUrl}/ExcelUpload/importMemberDataExcel`,
    specializationRoleValue: `${baseUrl}/dropdown/getSpecializationRoleAdmin`,
    batchRoleValue: `${baseUrl}/dropdown/getBatchRoleAdmin`,
    useSkillsValue: `${baseUrl}/dropdown/getAutoCompleteSkill`,
    useProgrambyCommunityValue: `${baseUrl}/dropdown/getProgrambyCommunity`,
  },
  event: {
    eventList: `${baseUrl}/Event/list`,
    view: `${baseUrl}/Event/view`,
    get: `${baseUrl}/Event`,
    add: `${baseUrl}/Event/create`,
    update: `${baseUrl}/Event/update`,
    delete: `${baseUrl}/Event/delete`,
    approveEvent: `${baseUrl}/Event/approveEvent`,
    rejectEvent: `${baseUrl}/Event/rejectEvent`,
    eventsCategoryValues: `${baseUrl}/dropdown/getEventCategoryValues`,
    eventStatusValues: `${baseUrl}/dropdown/getEventStatus`,
    getPaymentStatus: `${baseUrl}/dropdown/getIsPaymentStatus`,
    deleteEventImage: `${baseUrl}/Document/imageDelete`,
    eventValues: `${baseUrl}/dropdown/getEventForFeeCollection`,
    paymentModeValues: `${baseUrl}/dropdown/getPaymentMode`,
    bankValues: `${baseUrl}/dropdown/getBanklist`,
  },
  eventRegistration: {
    eventRegistrationList: `${baseUrl}/EventRegistration/list`,
    markAttendance: `${baseUrl}/EventRegistration/markattendance`,
    bulkMarkAttendance: `${baseUrl}/EventRegistration/bulkmarkattendance`,
    getEventRegistrationStatistics: `${baseUrl}/EventRegistration/getEventRegistrationStatistics`,
    getPaymentStatistics: `${baseUrl}/EventRegistration/getERPaymentStatistics`,
    addMemberEventRegistration: `${baseUrl}/EventRegistration/offlineEventRegistration`,
    collectFee: `${baseUrl}/EventRegistration/offlineEventRegistrationPaymentCollection`,
  },
  country: {
    list: `${baseUrl}/country/list`,
    get: `${baseUrl}/country`,
    view: `${baseUrl}/country/view`,
    delete: `${baseUrl}/country/delete`,
    add: `${baseUrl}/country/create`,
    update: `${baseUrl}/country/update`,
    values: `${baseUrl}/dropdown/getCountry`,
    stateValues: `${baseUrl}/dropdown/getStateByCountry`,
  },
  industry: {
    list: `${baseUrl}/industry/list`,
    get: `${baseUrl}/industry`,
    view: `${baseUrl}/industry/view`,
    delete: `${baseUrl}/industry/delete`,
    add: `${baseUrl}/industry/create`,
    update: `${baseUrl}/industry/update`,
    values: `${baseUrl}/dropdown/getIndustry`,
  },
  skill: {
    list: `${baseUrl}/skill/list`,
    get: `${baseUrl}/skill`,
    view: `${baseUrl}/skill/view`,
    delete: `${baseUrl}/skill/delete`,
    add: `${baseUrl}/skill/create`,
    update: `${baseUrl}/skill/update`,
    values: `${baseUrl}/dropdown/getSkils`,
    autoCompleteValues: `${baseUrl}/dropdown/getAutoCompleteSkill`,
  },
  institute: {
    list: `${baseUrl}/institute/list`,
    get: `${baseUrl}/institute`,
    view: `${baseUrl}/institute/view`,
    delete: `${baseUrl}/institute/delete`,
    deleteImage: `${baseUrl}/Document/imageDelete`,
    add: `${baseUrl}/institute/create`,
    update: `${baseUrl}/institute/update`,
    useAllInstituteValue: `${baseUrl}/dropdown/getAllInstitute`,
    communityWiseValues: `${baseUrl}/dropdown/getinstitute`,
    // univserityValues: `${baseUrl}/dropdown/getuniversity`,
    valuesByCommunityId: `${baseUrl}/dropdown/getInstituteByCommunityID`,
    useProgramByInstituteValues: `${baseUrl}/dropdown/getProgram`,
    useCourseRolebyInstituteValues: `${baseUrl}/dropdown/getCourseRoleAdmin`,
  },
  prominentMember: {
    list: `${baseUrl}/prominentMember/list`,
    view: `${baseUrl}/prominentMember/view`,
    get: `${baseUrl}/prominentMember`,
    delete: `${baseUrl}/prominentMember/delete`,
    add: `${baseUrl}/prominentMember/create`,
    update: `${baseUrl}/prominentMember/update`,
  },
  document: {
    imageDelete: `${baseUrl}/Document/delete`,
  },
  university: {
    list: `${baseUrl}/university/list`,
    get: `${baseUrl}/university`,
    view: `${baseUrl}/university/view`,
    delete: `${baseUrl}/university/delete`,
    add: `${baseUrl}/university/create`,
    update: `${baseUrl}/university/update`,
    univserityValues: `${baseUrl}/dropdown/getuniversity`,
    communityWiseUniversityValues: `${baseUrl}/dropdown/getCommunityWiseUniversity`,
  },
  course: {
    list: `${baseUrl}/course/list`,
    get: `${baseUrl}/course`,
    view: `${baseUrl}/course/view`,
    delete: `${baseUrl}/course/delete`,
    add: `${baseUrl}/course/create`,
    update: `${baseUrl}/course/update`,
    courseValues: `${baseUrl}/dropdown/getCourse`,
  },
  specialization: {
    list: `${baseUrl}/specialization/list`,
    get: `${baseUrl}/specialization`,
    view: `${baseUrl}/specialization/view`,
    delete: `${baseUrl}/specialization/delete`,
    add: `${baseUrl}/specialization/create`,
    update: `${baseUrl}/specialization/update`,
    getAllspecializationValues: `${baseUrl}/dropdown/getAllSpecialization`,
    specializationValues: `${baseUrl}/dropdown/getSpecialization`,
  },
  courseSpecialization: {
    list: `${baseUrl}/courseSpecialization/list`,
    get: `${baseUrl}/courseSpecialization`,
    view: `${baseUrl}/courseSpecialization/view`,
    delete: `${baseUrl}/courseSpecialization/delete`,
    add: `${baseUrl}/courseSpecialization/create`,
    update: `${baseUrl}/courseSpecialization/update`,
    SpecializationByCourseValues: `${baseUrl}/dropdown/getSpecializationbyCourseID`,
  },
  program: {
    list: `${baseUrl}/program/list`,
    get: `${baseUrl}/program`,
    view: `${baseUrl}/program/view`,
    delete: `${baseUrl}/program/delete`,
    add: `${baseUrl}/program/create`,
    update: `${baseUrl}/program/update`,
    programValues: `${baseUrl}/dropdown/getProgram`,
  },
  news: {
    list: `${baseUrl}/news/list`,
    get: `${baseUrl}/news`,
    view: `${baseUrl}/news/view`,
    delete: `${baseUrl}/news/delete`,
    add: `${baseUrl}/news/create`,
    update: `${baseUrl}/news/update`,
    deleteImage: `${baseUrl}/Document/imageDelete`,
  },
  newsCategory: {
    list: `${baseUrl}/newsCategory/list`,
    get: `${baseUrl}/newsCategory`,
    view: `${baseUrl}/newsCategory/view`,
    delete: `${baseUrl}/newsCategory/delete`,
    add: `${baseUrl}/newsCategory/create`,
    update: `${baseUrl}/newsCategory/update`,
    newsCategoryValues: `${baseUrl}/dropdown/getNewsCategoryValues`,
  },
  jobPosting: {
    list: `${baseUrl}/jobPosting/list`,
    get: `${baseUrl}/jobPosting`,
    view: `${baseUrl}/jobPosting/view`,
    delete: `${baseUrl}/jobPosting/delete`,
    add: `${baseUrl}/jobPosting/create`,
    update: `${baseUrl}/jobPosting/update`,
    approveEvent: `${baseUrl}/jobPosting/approveJobPosting`,
    rejectEvent: `${baseUrl}/jobPosting/rejectJobPosting`,
    jobPostingStatus: `${baseUrl}/dropdown/getJobPostingStatus`,
  },
  achievement: {
    list: `${baseUrl}/achievement/list`,
    get: `${baseUrl}/achievement`,
    view: `${baseUrl}/achievement/view`,
    delete: `${baseUrl}/achievement/delete`,
    add: `${baseUrl}/achievement/create`,
    update: `${baseUrl}/achievement/update`,
    approveEvent: `${baseUrl}/achievement/approveAchievement`,
    rejectEvent: `${baseUrl}/achievement/rejectAchievement`,
    achievementStatus: `${baseUrl}/dropdown/getAchievementStatus`,
    deleteImage: `${baseUrl}/Document/imageDelete`,
  },
  testimonial: {
    list: `${baseUrl}/testimonial/list`,
    get: `${baseUrl}/testimonial`,
    view: `${baseUrl}/testimonial/view`,
    delete: `${baseUrl}/testimonial/delete`,
    add: `${baseUrl}/testimonial/create`,
    update: `${baseUrl}/testimonial/update`,
    batchValues: `${baseUrl}/dropdown/getBatch`,
    memberLabelValues: `${baseUrl}/dropdown/getAutoCompleteMember`,
    deleteTestimonialImage: `${baseUrl}/Document/imageDelete`,
  },
  user: {
    list: `${baseUrl}/user/list`,
    get: `${baseUrl}/user`,
    view: `${baseUrl}/user/view`,
    delete: `${baseUrl}/user/delete`,
    add: `${baseUrl}/user/create`,
    update: `${baseUrl}/user/update`,
    updateProfile: `${baseUrl}/user/updateProfile`,
    communityValues: `${baseUrl}/dropdown/getCommunities`,
    resetPassword: `${baseUrl}/account/resetPassword`,
    forgotPassword: `${baseUrl}/account/forgotPassword`,
    changePassword: `${baseUrl}/account/changePassword`,
    useCommunityCount: `${baseUrl}/user/getCommunityCount`,
    info: `${baseUrl}/account/manage/info`,
  },
  community: {
    list: `${baseUrl}/community/list`,
    get: `${baseUrl}/community`,
    view: `${baseUrl}/community/view`,
    delete: `${baseUrl}/community/delete`,
    add: `${baseUrl}/community/create`,
    update: `${baseUrl}/community/update`,
    Values: `${baseUrl}/dropdown/getCommunity`,
    deleteImage: `${baseUrl}/Document/imageDelete`,
    // stateValues: `${baseUrl}/dropdown/getStateByCountry`,
  },
  emailTemplate: {
    list: `${baseUrl}/emailTemplate/list`,
    get: `${baseUrl}/emailTemplate`,
    view: `${baseUrl}/emailTemplate/view`,
    delete: `${baseUrl}/emailTemplate/delete`,
    add: `${baseUrl}/emailTemplate/create`,
    update: `${baseUrl}/emailTemplate/update`,
    emailTemplateValues: `${baseUrl}/dropdown/getEmailTemplate`,
    deleteAttachmentID: `${baseUrl}/Document/imageDelete`,
  },
  campaign: {
    list: `${baseUrl}/campaign/list`,
    get: `${baseUrl}/campaign`,
    view: `${baseUrl}/campaign/view`,
    delete: `${baseUrl}/campaign/delete`,
    add: `${baseUrl}/campaign/create`,
    update: `${baseUrl}/campaign/update`,
    useCampaignMemberValues: `${baseUrl}/campaign/getCampaignMember`,
    cancelCampaign: `${baseUrl}/campaign/cancelCampaign`,
    stopCampaign: `${baseUrl}/campaign/stopCampaign`,
    resumeCampaign: `${baseUrl}/campaign/resumeCampaign`,
  },
  campaignItems: {
    list: `${baseUrl}/CampaignItems/list`,
  },
  page: {
    list: `${baseUrl}/page/list`,
    get: `${baseUrl}/page`,
    view: `${baseUrl}/page/view`,
    delete: `${baseUrl}/page/delete`,
    add: `${baseUrl}/page/create`,
    update: `${baseUrl}/page/update`,
    // values: `${baseUrl}/dropdown/getCountry`,
    // stateValues: `${baseUrl}/dropdown/getStateByCountry`,
  },
  whatsAppCampaign: {
    listTemplates: `${baseUrl}/WhatsAppCampaign/list-templates`,
    createTemplate: `${baseUrl}/WhatsAppCampaign/create-template`,
    updateTemplate: `${baseUrl}/WhatsAppCampaign/update-template`,
    deleteTemplate: `${baseUrl}/WhatsAppCampaign/delete-template`,
    templateValues: `${baseUrl}/dropdown/getWhatsappTemplates`,
    listLogs: `${baseUrl}/WhatsAppCampaign/list-logs`,
    send: `${baseUrl}/WhatsAppCampaign/send`,
  },
};
